// extracted by mini-css-extract-plugin
export default {"test_card":"PartWork_test_card__wP2ue"};